define('core/views/RichMediaLinkView',[
    'backbone',

    'core/utils',
    'core/templates/postMediaInlineLink',
], function (
    Backbone,

    utils,
    postMediaInlineLinkTemplate
) {
    'use strict';

    return Backbone.View.extend({
        tagName: 'span',

        events: {
            'click [data-action=expand-collapse-media]': 'handleToggle',
        },

        initialize: function (options) {
            // Expects same model and media as RichMediaView
            this.media = options.media;

            // Extract link information
            var $link = options.$link;
            this.linkText = $link.text();
            this.linkHref = $link.attr('href');
            this.linkDomain = utils.getDomain(this.linkHref);
            this.linkHasUserText = this.isUserText($link);

            // Find correct title
            this.hasGenericMessage = false;
            if (this.linkHasUserText) {
                this.mediaLinkText = this.linkText;
            } else if (this.media.get('title')) {
                this.mediaLinkText = utils.niceTruncate(this.media.get('title'), 60);
            } else {
                this.hasGenericMessage = true;
                this.mediaLinkText = this.model.get('providerExpandMessage');
            }

            this.listenTo(this.model, 'change:deferred', this.render);
            this.listenTo(this.model, 'change:activated', this.onChangeActivated);
        },

        isUserText: function ($link) {
            // Try to guess if the user has customized the link text.
            if ($link[0].nodeName !== 'A')
                return false;
            var text = ($link.text() || '').toLowerCase();
            if (!text)
                return false;
            // If the text starts with a http or www it's unlikely to be customized
            if (text.indexOf('http') === 0 || text.indexOf('www') === 0)
                return false;
            // Remove the trailing ... our server adds
            text = text.replace(/\.\.\.$/, '');
            // If the href contains the text it's unlikely to be customized
            var href = ($link.attr('href') || '').toLowerCase();
            return href.indexOf(text) === -1;
        },

        render: function () {
            var mediaLinkText = this.mediaLinkText;
            // Use correct collapse message if we have one
            if (this.hasGenericMessage) {
                if (this.model.get('activated'))
                    mediaLinkText = this.model.get('providerCollapseMessage');
            }

            this.$el.html(postMediaInlineLinkTemplate({
                model: this.model.toJSON(),
                text: this.linkText,
                href: this.linkHref,
                mediaLinkText: mediaLinkText,
                domain: this.linkDomain,
                hasUserText: this.linkHasUserText,
            }));

            return this;
        },

        onChangeActivated: function () {
            // If there is a generic view / hide, re-render
            if (this.hasGenericMessage)
                this.render();
        },

        handleToggle: function (evt) {
            if (!this.model.get('deferred')) {
                this.model.set('activated', !this.model.get('activated'));
                // Only prevent the link from opening if the media is collapsible.
                // If the media is deferred, this view looks like a normal link
                // and should function as the user expects.
                if (evt && evt.preventDefault)
                    evt.preventDefault();
            }
        },
    });
});

